module.exports = __webpack_public_path__ + "img/delete.c01d8c4e.png";